import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';
import StatusTagCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/status-tag-cell';

function MessageCell(props) {
  const { cell } = props;

  const displayVal = cell
    ? typeof cell.value === 'object'
      ? cell.value?.name
      : cell.value || cell.name
    : '';

  return (
    <div className="fx actr tw-gap-2">
      <StatusTagCell {...props} />
      <div className="ellipsis" title={displayVal}>
        {displayVal ? <div>{displayVal}</div> : <DisabledTag>NA</DisabledTag>}
      </div>
    </div>
  );
}

export default MessageCell;
